import { Button, DatePicker, Flex, Grid } from 'antd'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import {
  QUICK_RANGES,
  isQuickRange,
  quickRange,
  tenantToday,
  type DayRange,
  type QuickRange,
} from '@/shared/lib/tenantDay'

const ISO_DAY = 'YYYY-MM-DD'

interface DayRangeBarProps {
  range: DayRange
  onChange: (range: DayRange) => void
}

/**
 * Sana oralig'i va tez tanlash tugmalari.
 *
 * <h2>⚠️ SANA TENANT ZONASIDA</h2>
 * Tanlagichdan KALENDAR KUNI olinadi (`YYYY-MM-DD`), on emas: `dayjs`
 * brauzer zonasidagi qiymat qaytaradi, foydalanuvchi esa ekranda
 * KO'RGAN sanani tanlaydi. Onga aylantirish `tenantRangeWindow` da,
 * tenant zonasida bo'ladi. Kobul tenantida (UTC+04:30) `dayjs` yo'li
 * kuniga yarim soat davomida oraliqni bir kunga surib yuborardi —
 * JIMGINA, chunki so'rov baribir 200 qaytaradi.
 *
 * <h2>⚠️ TEZ TANLASH TUGMALARI — bezak emas</h2>
 * Kassir kuniga o'nlab marta «bugun» ni so'raydi. Har safar kalendar
 * ochish telefonda uch bosish, tugma esa bitta. Ular ham
 * `tenantToday()` dan hisoblanadi, `new Date()` dan emas.
 *
 * <h2>⚠️ NEGA ALOHIDA KOMPONENT</h2>
 * IKKI ekran ishlatadi: `OperationsFilter` (Mening amallarim) va
 * «Berilgan paketlar» (2026-08-20). Nusxa ko'chirilsa ikkinchi
 * nusxada `disabledDate` yoki zona qarori jimgina eskirardi.
 */
export function DayRangeBar({ range, onChange }: DayRangeBarProps) {
  const { t } = useTranslation()
  const screens = Grid.useBreakpoint()
  const isMobile = screens.md === false
  const today = tenantToday()

  return (
    <Flex vertical gap={10}>
      <DatePicker.RangePicker
        value={[dayjs(range.from), dayjs(range.to)]}
        onChange={(value) => {
          const from = value?.[0]
          const to = value?.[1]
          if (from && to) onChange({ from: from.format(ISO_DAY), to: to.format(ISO_DAY) })
        }}
        // ⚠️ Kelajakdagi kun TO'SILADI: server u davr uchun har doim
        // bo'sh ro'yxat beradi va kassir buni nosozlik deb o'qirdi.
        disabledDate={(value) => value.format(ISO_DAY) > today}
        allowClear={false}
        inputReadOnly
        size="large"
        style={{ width: isMobile ? '100%' : 280, height: 44 }}
      />

      <Flex gap={8} wrap>
        {QUICK_RANGES.map((kind: QuickRange) => (
          <Button
            key={kind}
            size={isMobile ? 'middle' : 'small'}
            type={isQuickRange(range, kind) ? 'primary' : 'default'}
            onClick={() => onChange(quickRange(kind))}
            style={isMobile ? { flex: '1 1 68px' } : undefined}
          >
            {t(`myOperations.quick.${kind}`)}
          </Button>
        ))}
      </Flex>
    </Flex>
  )
}
